import _ from 'lodash'
import QuoteHelper from "./QuoteHelper";

class DeskingHelper {
    constructor(quotes, dealState) {
        this.quotes = quotes || []
        this.dealState = dealState
    }

    quotesByTermAndLender = () => {
        const map = {}
        this.quotes.map((quote) => {
            const term = quote.term
            const lender = quote.lender_name

            if (!(term in map)) {
                map[term] = {[lender]: quote}
            } else {
                map[term][lender] = quote
            }
        })

        return map
    }

    quotesByLenderAndTerm = () => {
        const map = {}
        this.quotes.map((quote) => {
            const helper = new QuoteHelper(null, quote)
            const lender = helper.lender()
            const term = helper.term()

            if (!(lender in map)) {
                map[lender] = {[term]: quote}
            } else {
                map[lender][term] = quote
            }
        })
        return map
    }

    lenders = () => _.uniq(this.quotes.map((quote) => {
        // const helper = new QuoteHelper(null, quote)
        // return helper.lender()
        return quote.lender_name
    }))

    terms = () => _.uniq(this.quotes.map((quote) => {
        // const helper = new QuoteHelper(null, quote)
        // return helper.term()
        return quote.term
    })).sort()

    termsForLender = (lender) => _.uniq(this.quotes.flatMap((quote) => {
        const helper = new QuoteHelper(null, quote)
        const quoteLender = helper.lender()
        if (lender === quoteLender) {
            return [Number(helper.term())]
        } else {
            return []
        }
    }))

    quotesForTerm = (term) => this.quotes.filter((quote) => {
        return String(term) === String(quote.term)
    })

    quotesForTermsSortedByBest = (term, isPurchase) => {
        const quotesForTerm = this.quotesForTerm(term)

        const sorted = quotesForTerm.sort((a, b) => {
            return a.payment - b.payment
        })

        return sorted
    }

}

export default DeskingHelper